import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const SectionWrap = styled.section`
  margin: 50px 0;
  @media ${device.tablet} {
    margin: 120px 0;
  }
`;

export const Wrap = styled.div``;

export const TitleWrap = styled.div`
  background-color: ${themes.colors.white};
  display: flex;
  align-items: center;
  margin: 0px 0 30px;
`;

export const StyledSectionTitle = styled.h2`
  width: 100%;
  color: ${themes.colors.primary};
  font-size: ${themes.textSize.l1};
  max-width: 400px;
  margin: 0 auto;
  background-color: ${themes.colors.white};
  text-align: center;
  border-top: 4px solid ${themes.colors.primary};
  padding-top: 12px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;
